import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { GroupListRequestBody, GroupListResponse } from "./types";

export class GroupListAPI extends BaseAPI<
  GroupListRequestBody,
  GroupListResponse
> {
  protected route = ApiRoutes.group.list;
  protected method = RequestMethod.GET;
  protected params = ["sort_key", "sort_order"];
}
